import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

export const Wrapper = styled.div`
    display: flex;
    gap: 24px;
    width: 100%;
    border-radius: 6px;
`;

export const MetricWrapper = styled.div<{ width?: string }>`
    flex-grow: 1;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px ${rgba(colorsPalettes.carbon[500], 0.08)};
    width: ${({ width = "100%" }) => width};
    min-width: 320px;
    border-radius: 6px;
`;
